import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const dayOfMonthGridStyleId = 'wb-v2-day-of-month-grid-theme';

export const dayOfMonthGridBridgeStyles = {
  'wb-day-of-month-grid': {
    '--local-day-grid-gap': '4px',
    '--local-day-grid-cell-height': '30px',
    '--local-day-grid-cell-radius': tokens.radius.xs,
    '--local-day-grid-cell-bg': tokens.color.background.primary,
    '--local-day-grid-cell-border': tokens.color.border.primary,
    '--local-day-grid-cell-color': tokens.color.text.secondary,
    '--local-day-grid-cell-font-family': tokens.font.family.body,
    '--local-day-grid-cell-font-size': tokens.font.size.textSm,
    '--local-day-grid-cell-line-height': tokens.lineHeight.textSm,
    '--local-day-grid-cell-hover-bg': tokens.color.background.secondary,
    '--local-day-grid-cell-hover-border': tokens.color.border.brand,
    '--local-day-grid-focus-ring': tokens.focusRing.default,
    '--local-day-grid-selected-bg': tokens.color.background.brandSolid,
    '--local-day-grid-selected-hover-bg': tokens.color.background.brandSolidHover,
    '--local-day-grid-selected-border': tokens.color.border.brand,
    '--local-day-grid-selected-color': tokens.color.text.primaryOnBrand,
    '--local-day-grid-footnote-color': tokens.color.text.tertiary,
    '--local-day-grid-footnote-font-size': tokens.font.size.textXs,
    '--local-day-grid-footnote-line-height': tokens.lineHeight.textXs,
    '--local-day-grid-footnote-margin': tokens.spacing.sm,
  },
};
